import { Alert, Box } from "@mui/material";
import { ReactNode } from "react";

import { GeneralDeferredValueStatus, IGeneralDeferredValueDto } from "@/core/api/generated/v1";

import NoDataAlert from "../../AppAlerts/NoDataAlert";
import { DotsLoading } from "../../Progress/DotsLoading";
import AppTypography from "../../Text/AppTypography";

interface GeneralDeferredValueDtoLocal extends IGeneralDeferredValueDto {
  value?: unknown;
}

interface GeneralDeferredValueDisplayProps {
  value: Nil<GeneralDeferredValueDtoLocal>;
  pendingTitle?: ReactNode;
  noValue?: ReactNode;
  children: ReactNode;
}

export default function GeneralDeferredValueDisplay({
  value,
  pendingTitle,
  noValue,
  children,
}: GeneralDeferredValueDisplayProps) {
  return (
    <>
      {value?.status === GeneralDeferredValueStatus.Success &&
        (value?.value ? children : noValue || <NoDataAlert title='No data.' />)}

      {value?.status === GeneralDeferredValueStatus.Failed && (
        <AppTypography variant='body2' color='error'>
          {value?.displayError}
        </AppTypography>
      )}

      {value?.status === GeneralDeferredValueStatus.Pending && (
        <Box>
          <Alert severity='info' icon={<DotsLoading />}>
            <Box>{pendingTitle || "Not available yet, please wait."}</Box>
          </Alert>
        </Box>
      )}
    </>
  );
}
